import React from "react";
import { createRoutesFromChildren, matchRoutes, useLocation, useNavigationType } from "react-router-dom";
import * as Sentry from "@sentry/react";
import { reactRouterV6BrowserTracingIntegration } from "@sentry/react";
import env from "react-dotenv";

import packageInfo from "../package.json";

Sentry.init({
	dsn: env.SENTRY_IO_DSN,
	environment: process.env.NODE_ENV,
	release: `dream-client-v2@${packageInfo.version}`,
	sendDefaultPii: false,
	integrations: [
		reactRouterV6BrowserTracingIntegration({
			useEffect: React.useEffect,
			useLocation,
			useNavigationType,
			matchRoutes,
			createRoutesFromChildren,
		}),
	],
	tracesSampleRate: parseFloat(env.SENTRY_IO_TRACES_SAMPLE_RATE),
	tracePropagationTargets: ["localhost", /^https:\/\/api-v2(-dev)?\.irtdream\.co\.uk/],
	replaysOnErrorSampleRate: 1.0,
});
